import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { Alert, Box } from "@mui/material";
import { BasicPage } from "./BasicPage";

/**
 * RoleProtectedRoute
 * Prevents certain roles from accessing specific routes
 * @param {Array} blockedRoles - Array of role names that should be blocked (e.g., ['Buyer'])
 * @param {ReactElement} children - The component to render if access is allowed
 * @param {string} redirectTo - Where to redirect blocked users (default: /web/welcome)
 * @param {string} message - Custom message to show blocked users
 */
export const RoleProtectedRoute = ({ 
    blockedRoles = [],
    children,
    redirectTo = "/web/welcome",
    message = "Sie haben keine Berechtigung für diese Seite."
}) => {
    const { claims } = useAuth();

    // Check if user's role is in the blocked list
    const isBlocked = claims && blockedRoles.includes(claims.role);

    if (isBlocked) {
        // Option 1: Redirect (uncomment if you want immediate redirect)
        // return <Navigate to={redirectTo} />;
        
        // Option 2: Show message (better UX)
        return (
            <BasicPage title="Zugriff verweigert">
                <Box sx={{ p: 3 }}>
                    <Alert severity="warning">
                        {message}
                    </Alert>
                    <Box sx={{ mt: 2 }}>
                        <p>
                            Ihre aktuelle Rolle erlaubt keinen Zugriff auf diese Seite.
                            Wenn Sie glauben, dass dies ein Fehler ist, wenden Sie sich bitte an Ihren Administrator.
                        </p>
                    </Box>
                </Box>
            </BasicPage>
        );
    }

    return children;
};

